// extracted by mini-css-extract-plugin
export default {"calenderDesign":"Index_calenderDesign__fmWjO","calenderitself":"Index_calenderitself__W0aFu"};